// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResizeText from 'vue-resize-text'
// import axios from 'axios'
import config from './config/config.json'
import App from './App'
import store from './store/store'
import Api from './services/api'
import VueResource from 'vue-resource'
import VueFormulate from '@braid/vue-formulate'
import VueRouter from 'vue-router'
import RotationScreen from './components/rotation/RotationScreen.vue'
import LoginPage from './components/pages/LoginPage.vue'
import CurrentMotionPage from './components/pages/CurrentMotionPage.vue'
import SpeakersListPage from './components/pages/SpeakersListPage.vue'
import OnScreenPage from './components/pages/ScreenPage.vue'
import CurrentMotionControlPanelPage from './components/pages/CurrentMotionControlPanelPage.vue'
import ManageScreenPage from './components/pages/ManageScreenPage.vue'
import SettingsPage from './components/pages/SettingsPage.vue'
import AccessDeniedPage from './components/pages/AccessDeniedPage.vue'
import CardsPage from './components/pages/CardsPage.vue'
import ScreenshotsManagerPage from './components/screenshots/ScreenshotsManagerPage.vue'
import OntimeScreen from './components/ontime/OntimeScreen.vue'
import PresidentsScreen from './components/motions/PresidentsScreen.vue'
import ToastService from 'primevue/toastservice'
import Pusher from 'pusher-js'
import eventBus from './services/event-bus'
import ConfirmationService from 'primevue/confirmationservice'
import VuePageTransition from 'vue-page-transition'
import VueTimeago from 'vue-timeago'
import VueExpandableImage from 'vue-expandable-image'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

const toastOptions = {
  // You can set your default options here
}

Vue.use(ToastService)
Vue.use(ConfirmationService)
Vue.use(VueRouter)
Vue.use(VueFormulate)
Vue.use(VueResizeText)
Vue.use(VueResource)
Vue.use(VuePageTransition)
Vue.use(VueExpandableImage)
Vue.use(Toast, toastOptions)

Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en', // Default locale
  // We use `date-fns` under the hood
  // So you can use all locales from it
  locales: {
    // 'zh-CN': require('date-fns/locale/zh_cn'),
    // ja: require('date-fns/locale/ja')
  }
})

Vue.config.productionTip = false

const apiUri = process.env.NODE_ENV === 'production' ? config.uri_production : config.uri
// const apiUri = config.uri_production
const pusherConfig = process.env.NODE_ENV === 'production' ? config.pusher : config.pusher_dev

console.log(pusherConfig)

const pusher = new Pusher(pusherConfig.appKey, {
  cluster: pusherConfig.cluster,
  channelAuthorization: {
    endpoint: `${apiUri}?r=pusher/auth&token=${store.getters['auth/token']}`,
    headers: {
      // 'Authorization': `Bearer ${store.getters['auth/token']}`
    }
  }
})

store.$channels = {}
store.$pusher = pusher
eventBus.$on('authenticated', () => {
  console.log('subscribing to channels')
  console.log(pusherConfig.appKey)
  const pusher2 = new Pusher(pusherConfig.appKey, {
    cluster: pusherConfig.cluster,
    channelAuthorization: {
      endpoint: `${apiUri}?r=pusher/auth&token=${store.getters['auth/token']}`,
      headers: {
        // 'Authorization': `Bearer ${store.getters['auth/token']}`
      }
    }
  })
  store.$pusher = pusher2
  store.$channels.user = pusher2.subscribe(`private-user.${store.getters['auth/username']}`)
  store.$channels.screen = pusher2.subscribe(`private-role.${store.getters['auth/user'].role}`)
  // store.$channels.screens = pusher2.subscribe('private-screens')
  store.$channels.screensPresence = pusher2.subscribe('presence-screens')
  store.dispatch('motions/initPusher')
  store.dispatch('screens/initPusher')
  store.dispatch('screenshots/initPusher')
  store.dispatch('settings/initPusher')
  /**
  store.$channels.screen.bind('motion-state-changed', (payload) => {
    store.dispatch('motions/motionStateChanged', payload)
  })
  store.$channels.screen.bind('motion-started', (payload) => {
    store.dispatch('motions/started', payload)
  })
  store.$channels.screen.bind('speaker-started', (payload) => {
    store.dispatch('motions/speakerStarted', payload)
  })
  store.$channels.screen.bind('speaker-finished', (payload) => {
    store.dispatch('motions/speakerFinished', payload)
  })
  store.$channels.screen.bind('speaker-withdrawn', (payload) => {
    store.dispatch('motions/speakerWithdrawn', payload)
  })
  store.$channels.screen.bind('prop-started', (payload) => {
    store.dispatch('motions/propStarted', payload)
  })
  store.$channels.screen.bind('prop-finished', (payload) => {
    store.dispatch('motions/propFinished', payload)
  })
    **/
})

const api = new Api(Vue.http, apiUri)
if (store.getters['auth/authenticated']) {
  api.setCredentials(store.getters['auth/credentials'])
  eventBus.$emit('authenticated', store.getters['auth/credentials'])
}

Vue.$api = api
store.$api = api

const routes = [
  {
    path: '/',
    name: 'screen',
    component: RotationScreen
  },
  {
    path: '/on-screen/:which?',
    name: 'on-screen',
    component: OnScreenPage
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/current-motion',
    name: 'current_motion',
    component: CurrentMotionPage
  },
  {
    path: '/manage-current-motion',
    name: 'current_motion_manage',
    component: CurrentMotionControlPanelPage
  },
  {
    path: '/manage-screen',
    name: 'manage_screen',
    component: ManageScreenPage
  },
  {
    path: '/speakers',
    name: 'speakers',
    component: SpeakersListPage
  },
  {
    path: '/cards',
    name: 'cards',
    component: CardsPage
  },
  {
    path: '/screens-monitor',
    name: 'screens_monitor',
    component: ScreenshotsManagerPage
  },
  {
    path: '/ontime',
    name: 'ontime',
    component: OntimeScreen
  },
  {
    path: '/president',
    name: 'presidents_screen',
    component: PresidentsScreen
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsPage
  },
  {
    path: '/access-denied',
    name: 'access_denied',
    component: AccessDeniedPage
  }
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  routes // short for `routes: routes`
})

router.beforeEach(async (to, from, next) => {
  const authenticated = store.getters['auth/authenticated']

  console.log(authenticated ? 'authenticated' : 'not authenticated')
  console.log(to)

  // redirect the user to login page if he is not authenticated
  if (!authenticated && to.name !== 'login') {
    // return { name: 'login' }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  store,
  router
})



// WEBPACK FOOTER //
// ./src/main.js